"use client";
// Force static generation
export const dynamic = 'force-static';

import DownloadButtons from "@/components/DownloadButtons";
import { motion } from "framer-motion";

export default function Home() {
  return (
    <div className="bg-gradient-to-b from-blue-50 via-white to-red-50 min-h-screen">
      {/* Hero Section */}
      <section className="relative overflow-hidden min-h-[70vh] flex items-center">
        <div className="absolute inset-0 bg-white"></div>
        <motion.div
          className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 md:pt-32 pb-20 md:pb-28 relative"
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight max-w-5xl mx-auto">
              <div className="font-[800] times-new-roman mb-2">
                <span className="text-[#E50024]">RIGHT</span>
                <span className="text-[#013388]">NOW</span>
              </div>
              <div className="bg-gradient-to-r from-[#E50024] via-[#E50024] to-[#013388] bg-clip-text text-transparent text-3xl md:text-4xl lg:text-5xl">
                News You Can Trust
              </div>
            </h1>
            <motion.p
              className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed font-medium"
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut", delay: 0.25 }}
            >
              Stay informed with real-time, trusted news that matters to you. Follow the stories shaping your world across politics, business, and culture—anytime, anywhere.
            </motion.p>
          </motion.div>

          {/* App Screenshot Banner */}
          <motion.div
            className="mt-16 relative"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.35 }}
          >
            {/* <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent h-32 bottom-0 z-10"></div> */}
            {/* <img
              src="/images/banner.jpg"
              alt="RightNow App Screenshots"
              className="w-full max-w-5xl mx-auto rounded-2xl shadow-2xl"
            /> */}
          </motion.div>
        </motion.div>
      </section>


      {/* Community / Trust Section */}
      <motion.section
        className="py-24 md:py-32 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-white via-blue-50 to-white"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <motion.h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
          >
            Independent, Real-Time Coverage
          </motion.h2>
          <motion.p
            className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
          >
            RightNow delivers fast, reliable reporting from sources you can trust. From breaking alerts to in-depth analysis, we help you cut through the noise so you can make confident decisions based on facts.
          </motion.p>
        </div>
      </motion.section>

      {/* CTA Section */}
      <motion.section
        className="py-24 md:py-32 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-[#E50024] via-[#E50024] to-[#013388]"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <motion.h2
            className="text-4xl md:text-5xl font-bold text-white mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
          >
            Ready to Stay Ahead of the Story?
          </motion.h2>
          <motion.p
            className="text-xl text-orange-100 mb-8 max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
          >
            Download RightNow today to get breaking news, live updates, and trusted analysis in one place.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
          >
            <DownloadButtons />
          </motion.div>
        </div>
      </motion.section>

    </div>
  );
}
